<template>
  <div class="surahSelection">
    <h3>Súry (Kapitoly)</h3>
    <div class="selectionBox">
      <select
        id="chapter_select"
        v-if="allSurahs.length"
        size="13"
        style="width: 100%"
        @change="changeSurah"
      >
        <option value="" @click="goToSurah()">All Chapters</option>
        <option
          v-for="(surah, index) in allSurahs"
          :key="index"
          :value="surah.surahNum"
          @click="goToSurah(surah.surahNum)"
          :selected="surahNum == surah.surahNum"
        >
          {{ surah.surahNum }}) {{ surah.czechName }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";
import $ from "jquery";

export default {
  name: "SurahSelection",
  data() {
    return {
      surahNum: this.$route.params.surahNum,
      ayahNum: this.$route.params.ayahNum,
      allSurahs: JSON.parse(localStorage.getItem("surahs")) || [],
    };
  },
  methods: {
    async getAllSurahs() {
      this.$store.dispatch("toggleLoader", true);
      let getRes = await api.getSurahs();
      if (!getRes.response) {
        this.allSurahs = getRes.data.data.surahs;
        localStorage.setItem("surahs", JSON.stringify(this.allSurahs));
      }
      if (!this.$route.path.includes("/search")) {
        this.$store.dispatch("toggleLoader", false);
      }
    },
    async changeSurah(e) {
      this.$emit("changeSurah", e.target.value);
    },
    async goToSurah(value) {
      if (!value) {
        this.$router.push({ path: "/" });
        return;
      }
      if (this.ayahNum) {
        this.$emit("changeSurah", value);
      }
    },
    async scrollToSelectedChapter() {
      let $s = $("#chapter_select");
      let point = this.surahNum > 10 ? this.surahNum - 10 : "";
      let optionTop = $s.find(`[value="${point}"]`).offset().top;
      let selectTop = $s.offset().top;

      $s.scrollTop($s.scrollTop() + (optionTop - selectTop));
    },
  },
  created() {
    this.getAllSurahs();
  },
  mounted() {
    this.scrollToSelectedChapter();
  },
};
</script>
<style lang="scss" scoped>
$global_color: #4c709b;
$global_color_lit: #4c709bcc;

.surahSelection {
  padding: 10px;
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 5px;

  h3 {
    font-size: 12px;
    font-weight: bold;
    margin: 0px;
  }
  .selectionBox {
    // background-color: #ccffb3;
    background-color: $global_color;
    padding: 5px 5px 1px 5px;
    // border: 1px #99ff66 solid;
    border: 1px $global_color solid;
    color: #003399;
    border-radius: 5px;

    select {
      cursor: pointer;
      font-family: arial;
      font-size: 12px;
    }
  }
}
</style>